import { forwardRef } from 'react'
import { NumberInput, NumberInputProps } from '@/components/ui/number-input'

export interface MoneyInputProps extends Omit<
  NumberInputProps,
  'decimalScale' | 'fixedDecimalScale' | 'stepper' | 'min'
> {
  currencySymbol?: string
}

export const MoneyInput = forwardRef<HTMLInputElement, MoneyInputProps>(
  ({ currencySymbol, suffix, inputClassName, ...props }, ref) => {
    return (
      <NumberInput
        ref={ref}
        min={0}
        stepper={0.01}
        decimalScale={2}
        fixedDecimalScale
        inputClassName={`text-right${inputClassName ? ` ${inputClassName}` : ''}`}
        suffix={suffix ?? (currencySymbol ? ` ${currencySymbol}` : undefined)}
        placeholder="0.00"
        {...props}
      />
    )
  }
)

MoneyInput.displayName = 'MoneyInput'
